import { USER_ROLES_TO_NAME } from 'src/constants/userSetting';
import { isAdminBlocked } from './accountStatus';
/**
 * Unknown MFA is its own rank: the backend reports null when it cannot read the state, and an
 * unknown account must not sort among the ones that are genuinely off.
 */
const mfaRank = mfaEnabled => {
  if (mfaEnabled === true) return 2;
  if (mfaEnabled === false) return 1;
  return 0;
};
const sortValue = (account, key) => {
  var _account$firstName, _account$lastName, _account$phone, _ref, _USER_ROLES_TO_NAME;
  switch (key) {
    case 'name':
      return "".concat((_account$firstName = account.firstName) !== null && _account$firstName !== void 0 ? _account$firstName : '', " ").concat((_account$lastName = account.lastName) !== null && _account$lastName !== void 0 ? _account$lastName : '').trim();
    case 'email':
      return account.email || account.newEmail || '';
    case 'phone':
      return ((_account$phone = account.phone) !== null && _account$phone !== void 0 ? _account$phone : '').replace(/\D/g, '');
    case 'mfa':
      return mfaRank(account.mfaEnabled);
    case 'role':
      return (_ref = (_USER_ROLES_TO_NAME = USER_ROLES_TO_NAME[account.userRole]) !== null && _USER_ROLES_TO_NAME !== void 0 ? _USER_ROLES_TO_NAME : account.userRole) !== null && _ref !== void 0 ? _ref : '';
    case 'status':
      return isAdminBlocked(account.isEnabled) ? 0 : 1;
    default:
      return '';
  }
};

/**
 * Sorts on what each cell shows rather than on the raw record, so the order always matches the
 * column the user clicked.
 */
export const sortAdminAccounts = (accounts, orderBy, order) => {
  if (!orderBy) return [...accounts];
  return [...accounts].sort((a, b) => {
    const aValue = sortValue(a, orderBy);
    const bValue = sortValue(b, orderBy);
    const comparison = typeof aValue === 'string' || typeof bValue === 'string' ? String(aValue).localeCompare(String(bValue), undefined, {
      sensitivity: 'base',
      numeric: true
    }) : aValue - bValue;
    return order === 'asc' ? comparison : -comparison;
  });
};